import RestService from "@/services/RestService";

function getChildren() {
  const data = {};
  return RestService.sendReq("get", "parent/children", data);
}

function getChildCourses(childId) {
  const data = {};
  return RestService.sendReq("get", `parent/children/${childId}/courses`, data);
}

function getChildDashboard(childId, period) {
  const data = {
    period,
  };
  return RestService.sendReq("get", `parent/children/${childId}/dashboard`, data);
}

function getChildCourseOverview(childId, courseId, period, progressRange) {
  const data = { period, progress_range: progressRange };
  return RestService.sendReq(
    "get",
    `parent/children/${childId}/courses/${courseId}/overview`,
    data
  );
}

function getChildProgress(childId, range) {
  const data = {
    range,
  };
  return RestService.sendReq("get", `parent/children/${childId}/progress`, data);
}

function getChildRecentEvents(childId, limit = 5) {
  const data = {
    limit,
  };
  return RestService.sendReq("get", `parent/children/${childId}/recent-events`, data);
}

function getChildActivityCenter(childId, filters = {}) {
  const data = Object.keys(filters).reduce((params, key) => {
    const value = filters[key];

    if (value !== null && value !== undefined && value !== "") {
      params[key] = value;
    }

    return params;
  }, {});
  return RestService.sendReq("get", `parent/children/${childId}/activity-center`, data);
}

function getChildActivityEventDetail(childId, eventId) {
  const data = {};
  return RestService.sendReq(
    "get",
    `parent/children/${childId}/activity-center/${eventId}`,
    data
  );
}

function getChildDiaryEvents(childId, params = {}) {
  const data = Object.keys(params).reduce((result, key) => {
    const value = params[key];
    if (value !== null && value !== undefined && value !== "") {
      result[key] = value;
    }
    return result;
  }, {});
  return RestService.sendReq("get", `parent/children/${childId}/diary/events`, data);
}

function getChildLessonPreview(childId, lessonId) {
  return RestService.sendReq(
    "get",
    `parent/children/${childId}/lessons/${lessonId}`,
    {}
  );
}

function getChildCourseLessons(childId, courseId) {
  return RestService.sendReq(
    "get",
    `parent/children/${childId}/courses/${courseId}/lessons`,
    {}
  );
}

function getChildReportCardPreview(childId) {
  const data = {};
  return RestService.sendReq("get", `parent/children/${childId}/report-card/preview`, data);
}

function getChildReportCardPdf(childId) {
  const data = {};
  return RestService.sendReq(
    "get",
    `parent/children/${childId}/report-card/pdf`,
    data,
    { responseType: "blob" }
  );
}

export default {
  getChildren,
  getChildCourses,
  getChildDashboard,
  getChildCourseOverview,
  getChildProgress,
  getChildRecentEvents,
  getChildActivityCenter,
  getChildActivityEventDetail,
  getChildDiaryEvents,
  getChildLessonPreview,
  getChildCourseLessons,
  getChildReportCardPreview,
  getChildReportCardPdf,
};
